import { LogLevel } from '@azure/msal-browser';
import { tenantID } from '~src/authconfig';
import { getClientId, getProtectedResources } from '../config';

export const msalConfig = {
	auth: {
		clientId: getClientId(), // not the same as API client ID
		authority: `https://login.microsoftonline.com/${tenantID}`,
		redirectUri: '/',
		postLogoutRedirectUri: '/',
		clientCapabilities: ['CP1'],
	},
	cache: {
		cacheLocation: 'localStorage',
		storeAuthStateInCookie: false,
	},
	system: {
		loggerOptions: {
			loggerCallback: (
				level: LogLevel,
				message: string,
				containsPii: Boolean
			) => {
				if (containsPii) {
					return;
				}
				switch (level) {
					case LogLevel.Error:
						console.error(message);
						return;
					case LogLevel.Info:
						// console.info(message);
						return;
					case LogLevel.Verbose:
						// console.debug(message);
						return;
					case LogLevel.Warning:
						// console.warn(message);
						return;
				}
			},
		},
	},
};

const protectedResources = getProtectedResources();

export const loginRequest = {
	scopes: [
		...protectedResources.overrides.scopes.read,
		...protectedResources.overrides.scopes.write,
	],
};
